// Import parent class.
import Milestone from './Milestone.js';

/**
 * GatedMilestone object generated by Goal app.
 *
 * @typedef {Object} GatedMilestone
 * @extends module:Goal.Model.Entity.Milestone
 * @namespace
 *
 * @memberof module:Goal.Model.Entity
 *
 * @property {String} id The Milestone id.
 * @property {Integer} goal The numeric target goal for the milestone.
 * @property {String} label The textual label for the milestone.
 * @property {Integer} start The date start timestamp for the milestone.
 * @property {Integer} end The date end timestamp for the milestone.
 * @property {String} startHuman Human readable version of the start timestamp for the milestone.
 * @property {String} endHuman Human readable version of the end timestamp for the milestone.
 */
class GatedMilestone extends Milestone {

	constructor(id, goal, label, startDate, endDate, startDateHuman, endDateHuman) {

		super(id, goal, label);

		this.startDate = startDate;
		this.endDate = endDate;
		this.startDateHuman = startDateHuman;
		this.endDateHuman = endDateHuman;
	}
}

export default GatedMilestone;